<template>
  <custom-dialog
    :value="isDialog"
    :buttons="[]"
    :title="$t('pleaseWait') | capitalize"
    title-icon="fa-clock"
    persistent
  >
    <v-container style="height: 400px">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          {{ $t("backgroundOperationsInProgress") | capitalize }} <br />
          {{ $t("pleaseWait") | capitalize }}
        </v-col>
        <v-col cols="6" class="text-center">
          <v-progress-circular :size="70" color="primary" indeterminate />
        </v-col>
      </v-row>
    </v-container>
  </custom-dialog>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";
import CustomDialog from "@/components/shared/layout/CustomDialog.vue";
@Component({
  components: { CustomDialog },
})
export default class WaitForRequestDialog extends Vue {
  get isDialog(): boolean {
    return this.$store.direct.state.isWaitingForRequestsDialog;
  }
}
</script>

<style scoped></style>
